// extracted by mini-css-extract-plugin
export default {"sportRulesContainer":"sport-rules_sportRulesContainer__9rluC"};